export default __webpack_public_path__ + "static/media/LoginBg.36bf3bd0.svg";